/* client/src/store/reducers/index.js
   (or whatever the current path for this file is) */
import { combineReducers } from 'redux';
import uiReducer        from '../uiSlice';      
// EXISTING reducers
import Auth            from './Auth';
import GeneralSetting  from './GeneralSetting';

// NEW: credit slice reducer
// ‼️  Path is relative to *this* file. If your folder structure differs,
//     adjust (“../creditSlice”, “./creditSlice”, etc.) accordingly.
import Credit from '../creditSlice';

const RootReducer = combineReducers({
  Auth,
  GeneralSetting,
  Credit,          // ← added, nothing else touched
  ui     : uiReducer, 
});

export default RootReducer;
